import one from "../assets/hobbies/1.png";
import two from "../assets/hobbies/2.png";
import three from "../assets/hobbies/3.png";
import four from "../assets/hobbies/4.png";
import five from "../assets/hobbies/5.png";
import six from "../assets/hobbies/6.png";
import seven from "../assets/hobbies/7.png";
import eight from "../assets/hobbies/8.png";
import nine from "../assets/hobbies/9.png";
import ten from "../assets/hobbies/10.png";
import eleven from "../assets/hobbies/11.png";
import twelve from "../assets/hobbies/12.png";
import thirteen from "../assets/hobbies/13.png";
import fourteen from "../assets/hobbies/14.png";
import fifteen from "../assets/hobbies/15.png";
import sixteen from "../assets/hobbies/16.png";
import seventeen from "../assets/hobbies/17.png";
import eighteen from "../assets/hobbies/18.png";
import nineteen from "../assets/hobbies/19.png";

export default [
    one,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten,
    eleven,
    twelve,
    thirteen,
    fourteen,
    fifteen,
    sixteen,
    seventeen,
    eighteen,
    nineteen,
];
